export class Transform {
    toTextValue = (body = null) => {
        let data = this.checkAndTakeJson(body);
        return {
            text: data.text,
            value: data.value
        };
    };

    takeNumber(body, key, init = 0) {

        let data = this.checkAndTakeJson(body);

        if (key in data) {
            const val = data[key];
            if (typeof val === "number") {
                return val;
            } else if (typeof val === "string") {
                try {
                    const val = Number.parseFloat(data[key]);
                    if (!isNaN(val)) {
                        return val;
                    }
                } catch {
                    return init;
                }
            }
        }
        return init;
    }

    takeInteger(body, key, init = 0) {

        let data = this.checkAndTakeJson(body);

        if (key in data) {
            try {
                const val = Number.parseInt(data[key]);
                if (!isNaN(val)) {
                    return val;
                }
            } catch (e) {
                // خطا در تبدیل به عدد صحیح
            }
        }
        return init;
    }

    takeString(body, key, init = "") {

        let data = this.checkAndTakeJson(body);

        if (key in data) {
            let val = data[key];
            if (typeof val === "string") {
                return val;
            } else if (val === undefined || val === null) {
                return init;
            } else {
                return String(val);
            }
        }
        return init;
    }

    takeBoolean(body, key, init = "") {
        let data = this.checkAndTakeJson(body);
        if (key in data) {
            let val = data[key];
            if (typeof val === "boolean") {
                return val;
            } else if (val === "true") {
                return true;
            } else if (val === "false") {
                return false;
            } else {
                return init;
            }
        }
        return init;
    }

    checkAndTakeJson = (data) => {
        try {
            return (typeof data === "object" && !Array.isArray(data)) ? {...data} : {};
        } catch (e) {
            console.log(e);
        }

        return data;
    }
    checkAndTakeArray = (data = []) => Array.isArray(data) ? data : [];

    toTitleCase(str = "") {
        if (str.length > 0) {
            let firstChar = str.charAt(0).toUpperCase();
            return firstChar + str.slice(1).toLowerCase();
        }
        return str;
    }

}
